import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  email,
  BooleanInput
} from "admin-on-rest";
import {
  validatePartnerDataCreate,
  validatePassword,
  validateCompanyNumber,
  validateZipCode
} from "./validations";
import {formStyle} from "./style";

class PartnerCreateForm extends React.Component {
  render() {
    const props = {...this.props};
    return (
      <Create title="resources.storeOwners.titleCreate" {...props}>
        <SimpleForm redirect="list" validate={validatePartnerDataCreate}>
          <TextInput
            label="resources.storeOwners.inputs.firstName"
            source="first_name"
          />
          <TextInput
            label="resources.storeOwners.inputs.lastName"
            source="last_name"
          />
          <TextInput
            label="resources.storeOwners.inputs.email"
            source="email"
            type="email"
            validate={email}
          />

          <TextInput
            label="resources.storeOwners.inputs.password"
            source="password"
            type="password"
            validate={validatePassword}
            style={formStyle.containerInput}
          />
          <TextInput
            label="resources.storeOwners.inputs.repeatPassword"
            source="password2"
            type="password"
            validate={validatePassword}
          />
          <div style={formStyle.clearFloatContainer} />

          <TextInput
            label="resources.storeOwners.inputs.companyName"
            source="company_name"
          />

          <TextInput
            label="resources.storeOwners.inputs.companyNumber"
            source="company_number"
            validate={validateCompanyNumber}
          />
          <TextInput
            label="resources.storeOwners.inputs.city"
            source="city"
            style={formStyle.containerInput}
          />

          <TextInput
            label="resources.storeOwners.inputs.postNumber"
            source="post_number"
            validate={validateZipCode}
          />

          <BooleanInput
            label="resources.storeOwners.inputs.active"
            source="active"
            defaultValue={true}
            elStyle={{display: "none"}}
          />
        </SimpleForm>
      </Create>
    );
  }
}

export default PartnerCreateForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/Partners/PartnerCreateForm.js